import { render, staticRenderFns } from "./Status.vue?vue&type=template&id=f9614e0a"
import script from "./Status.vue?vue&type=script&lang=js"
export * from "./Status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9614e0a')) {
      api.createRecord('f9614e0a', component.options)
    } else {
      api.reload('f9614e0a', component.options)
    }
    module.hot.accept("./Status.vue?vue&type=template&id=f9614e0a", function () {
      api.rerender('f9614e0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/recibo/Status.vue"
export default component.exports